
import React from 'react';
import './MainTitle.css';

function MainTitle() {
    return (
        <div style={{paddingTop:"16px"}} className="lato-bold main-title d-flex align-items-center justify-content-lg-start justify-content-around">
            <h1 className="common-heading common-personal-heading h1 text-matterhorn text-lg-center text-left lh-40 text-center ml-5 mr-5">
                Let's move ahead with your personal details
            </h1>
        </div>
    );
}

export default MainTitle;